<template>
  <div
    v-if="isLoading"
    class="loader-container"
    :class="{
      'padding-top': !isLinear && withPaddingTop,
      'is-linear': isLinear,
    }"
  >
    <v-progress-linear
      v-if="isLinear"
      indeterminate
      absolute
      :color="color"
      :height="$vuetify.breakpoint.mdAndUp ? 4 : 2"
    />
    <v-progress-circular
      v-else
      :color="color"
      indeterminate
      :size="$vuetify.breakpoint.mdAndUp ? 40 : 30"
    />
  </div>
</template>
<script>
export default {
  name: 'Loader',
  props: {
    isLoading: { type: Boolean, default: false },
    color: { type: String, default: 'primary' },
    withPaddingTop: { type: Boolean, default: false },
    isLinear: { type: Boolean, default: false },
  },
};
</script>
<style lang="scss" scoped>
.loader-container {
  width: 100%;
  text-align: center;
  &:not(.is-linear) {
    min-height: 50px;
  }
  &.padding-top {
    padding-top: 20px;
    min-height: 70px;
  }
}
</style>
